<div class="wrapper sg-full-height sg-flex-column">
  <div class="user-consent-header"><img class="sg-page-logo" [src]="logoSrc" /></div>
  <div class="sg-user-consent-container sg-flex-column sg-flex-auto sg-justify-center sg-items-center">
    <sg-text variant="sg-h2-standard" class="title">Updated Cookie Policy Consent</sg-text>
    <sg-text variant="sg-p3-standard" class="cookies-description sg-margin-left-30">
      We have updated our cookies policy to include additional usage analytics and user experience improvement cookies. By clicking “Accept”, you agree to our
      usage of cookies. You can learn more about our cookie policy
      <a class="sg-link" target="_blank" [routerLink]="[appName + '/cookie-policy']" [queryParams]="{ brand: 'standAlone' }">here</a>
      .
    </sg-text>
    @if (isLenderApp) {
      <sg-text variant="sg-p3-standard" class="cookies-description sg-margin-left-30">
        This includes
        <b>Mixpanel</b>
        for product analytics and masked session replay. By clicking “Accept” you also consent to Mixpanel — read its
        <a class="sg-link" target="_blank" rel="noopener" href="https://mixpanel.com/legal/privacy-policy/">privacy policy</a>
        .
      </sg-text>
    }
    <sg-text variant="sg-p2" class="customize-text">
      <mat-icon color="primary" inline="true">lightbulb_outline</mat-icon>
      You can always
      <a class="sg-link customize-link" (click)="toggleCustomSettings()">customize</a>
      your cookies preferences
    </sg-text>
    @if (isCustomeSettingsDisplayed$ | async) {
      <sg-cookies-settings class="cookies-settings" @detailExpand [formControl]="customSettings"></sg-cookies-settings>
    }
    <div [sg-blockable]="tracker.busy$ | async" blockerStyle="progressBar" blockerStyleDirection="start" class="sg-margin-left-28">
      <sg-button variant="primary" text="Accept" (onClick)="agreeUserConsent()"></sg-button>
    </div>
  </div>
</div>
